import React from 'react'
import PropTypes from 'prop-types'
import {
    SimpleGrid,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Region, regionPropType} from '@salesforce/commerce-sdk-react/components'

/**
 * This layout component displays its children in a 3 row x 2 column grid on mobile
 * and 2 row x 3 column grid on desktop.
 *
 * @param {componentProps} props
 * @param {regionType []} props.regions - The page designer regions for this component.
 * @param {object} props.data - The data for the component.
 * @param {string} props.typeId - A mapping of typeId's to react components representing the type.
 * @returns {React.ReactElement} - Grid component.
 */
export const MobileGrid3r2c = ({regions}) => {
    const styles = useMultiStyleConfig('containerStyles')

    return (
        <SimpleGrid
            className="mobile-3r-2c"
            columns={{base: 2, sm: 3}}
            spacing={4}
            {...styles.containerStyles}
        >
            {regions.map((region) => (
                <Region key={region.id} region={region} />
            ))}
        </SimpleGrid>
    )
}

MobileGrid3r2c.displayName = 'MobileGrid3r2c'

MobileGrid3r2c.propTypes = {
    // Internally Provided
    regions: PropTypes.arrayOf(regionPropType).isRequired
}

export default MobileGrid3r2c
